<section class="card">
  <p-table #dt [value]="stores" dataKey="shopId" [expandedRowKeys]="expandedRows" (onRowExpand)="onRowExpand($event)" (onRowCollapse)="onRowCollapse($event)" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" [scrollable]="true" scrollHeight="150vh" currentPageReportTemplate="Mostrando {first} - {last} de {totalRecords}" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-gridlines" [tableStyle]="{ 'min-width': '40rem' }" [globalFilterFields]="['shopName', 'shopSubscriptionName', 'shopDomain']">
    <ng-template #caption>
      <div class="flex items-center justify-between">
        <h2>Comercios</h2>
        <!-- <h5 class="m-0">Buscar Comercios</h5> -->
        <p-iconfield>
          <p-inputicon class="pi pi-search" />
          <input pInputText type="text" (input)="onInput($event)" placeholder="Busqueda Rápida" />
        </p-iconfield>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th style="width: 5rem"></th>
        <th pSortableColumn="shopName" style="width:20%">
          <div class="flex items-center gap-2">
            Nombre
            <p-sortIcon field="shopName" />
          </div>
        </th>
        <th pSortableColumn="shopId" style="width:20%">
          <div class="flex items-center gap-2">
            Id
            <p-sortIcon field="shopId" />
          </div>
        </th>
        <th pSortableColumn="shopSubscriptionName" style="width:20%">
          <div class="flex items-center gap-2">
            Plan
            <p-sortIcon field="shopSubscriptionName" />
          </div>
        </th>
        <th pSortableColumn="shopDomain" style="width:20%">
          <div class="flex items-center gap-2">
            Dominio
            <p-sortIcon field="shopDomain" />
          </div>
        </th>
        <th></th>
      </tr>
      
    </ng-template>
    <ng-template #body let-store let-expanded="expanded">
      <tr>
        <!-- <td><p-image [src]="store.image" alt="Image" width="100" />{{ store.shopName }}</td> -->
        <td>
          <p-button *ngIf="store.shopChilds" type="button" pRipple [pRowToggler]="store" [text]="true" severity="secondary" [rounded]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
        </td>
        <td><strong>{{ store.shopName }}</strong></td>
        <td>{{ store.shopId }}</td>
        <!-- <td><img [src]="store.shopImage" [alt]="store.shopName" width="50" class="shadow-lg" /></td> -->
        <td>{{ store.shopSubscription.shopSubscriptionName }}</td>
        <td><a href="https://{{ store.shopDomain }}" target="_blank" rel="noopener noreferrer"><i class="pi pi-spin pi-external-link"></i></a>   {{ store.shopDomain }} </td>
        <td>
          <p-button icon="pi pi-search" (click)="viewDetails(store.shopId)" severity="secondary" rounded />
        </td>
      </tr>
    </ng-template>
    <ng-template #expandedrow let-store>
      <tr>
        <td colspan="7">
          <div class="p-4">
            <h5>Tiendas hijas de {{ store.shopName }}</h5>
            <p-table [value]="store.shopChilds" dataKey="shopGuid">
              <ng-template #header>
                <tr>
                  <th pSortableColumn="shopId">
                    <div class="flex items-center gap-2">
                      Id
                      <p-sortIcon field="shopId" />
                    </div>
                  </th>
                  <th pSortableColumn="shopName">
                    <div class="flex items-center gap-2">
                      Nombre
                      <p-sortIcon field="shopName" />
                    </div>
                  </th>
                  <th pSortableColumn="shopSubscriptionName">
                    <div class="flex items-center gap-2">
                      Plan
                      <p-sortIcon field="shopSubscriptionName" />
                    </div>
                  </th>
                  <th pSortableColumn="shopDomain">
                    <div class="flex items-center gap-2">
                      Dominio
                      <p-sortIcon field="shopDomain" />
                    </div>
                  </th>
                  <th style="width: 4rem"></th>
                </tr>
              </ng-template>
              <ng-template #body let-child>
                <tr>
                  <td>{{ child.shopId }}</td>
                  <td>{{ child.shopName }}</td>
                  <td>{{ child.shopSubscriptionName }}</td>
                  <td><a href="https://{{ child.shopDomain }}" target="_blank" rel="noopener noreferrer"><i class="pi pi-spin pi-external-link"></i></a> {{ child.shopDomain }}</td>
                  <td>
                    <p-button icon="pi pi-search" (click)="viewDetails(child.shopId)" severity="secondary" rounded />
                  </td>
                </tr>
              </ng-template>
              <ng-template #emptymessage>
                <tr>
                  <td colspan="6">No posee tiendas hijas.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>